/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import Parser from 'html-react-parser';
import qs from 'qs';
import { rewriteAlertBanners, updateAlertBanners } from '../../actions';
import AlertDismissible from '../../components/kea/AlertDismissible';

const getTone = ({ status, titleKey }) => {
  if (titleKey === 'alerts.title.error') return 'error';

  const tones = {
    danger: 'error',
    dark: 'neutral',
    error: 'error',
    info: 'info',
    success: 'success',
    warning: 'warning',
  };
  return tones[status] || 'info';
};

const HIDE_ALERTS_PATTERNS = [
  /wizard/i,
  /welcome/i,
  /onboarding/i,
];

function isAlertNotApplicable(pathname) {
  return HIDE_ALERTS_PATTERNS.some((rx) => rx.test(pathname));
}

const AlertBanner = ({ location }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { settings: {
    alerts: {
      data,
      isFetching,
      actions,
    } },
  } = useSelector((store) => store);

  useEffect(() => {
    const parseOptions = { ignoreQueryPrefix: true };
    const qsObject = qs.parse(location.search, parseOptions);
    const action = actions[qsObject.banner];
    if (action) {
      dispatch(updateAlertBanners([action]));
    }
  }, []);

  const alertsIsNotAvailable = isFetching || (data.length === 0);
  if (alertsIsNotAvailable) {
    return null;
  }

  if (isAlertNotApplicable(location.pathname)) {
    return null;
  }

  const closeBanner = (key) => {
    let filtered = data.map((e, i) => ((i !== key) ? e : false));
    filtered = filtered.filter((e) => e);
    dispatch(rewriteAlertBanners(filtered));
  };

  return (
    <div className="alerts-banner-wrapper" data-testid="global-alert-stack">
      {
        data.map(({ id, title, titleKey, message, messageKey, status }, index) => {
          const localizedTitle = titleKey ? intl.formatMessage({ id: titleKey }) : title;
          const localizedMessage = messageKey ? intl.formatMessage({ id: messageKey }) : message;

          return (
            <AlertDismissible
              key={`${id}_${index}`}
              closeLabel={intl.formatMessage({ id: 'common.close' })}
              onClose={() => closeBanner(index)}
              title={localizedTitle}
              message={localizedMessage ? Parser(localizedMessage) : null}
              tone={getTone({ status, titleKey })}
            />
          );
        })
      }

    </div>
  );
};

export default AlertBanner;
